@if (formGroup()) {
  <div class="research-setting-field" [formGroup]="formGroup()">
    <div class="row">

      <button [disabled]="!enabled()"
        [class.disabled]="!enabled()"
        mat-icon-button class="remove-btn" type="button" (click)="removeField()">
        <mat-icon>remove_circle</mat-icon>
      </button>

      <mat-form-field appearance="fill">
        <mat-label>Query Type</mat-label>
        <mat-select formControlName="queryType" required>
          @for (type of researchDBTypes; track $index) {
            <mat-option [value]="type.value">
              {{ type.viewValue }}
              <mat-icon class="info" matSuffix
                [matTooltip]="type.infoText">
                info
              </mat-icon>
            </mat-option>
          }
        </mat-select>
        @if (formGroup().get('queryType')?.hasError('required')) {
          <mat-error>
            Query type is required
          </mat-error>
        }
      </mat-form-field>

      @if (papers(); as papers) {
        <p>{{ papers.length }} Paper effected, if you change this will be deleted, if this is paper is only found by
        this query</p>
      }
    </div>

    <div class="query-wrapper">
      <div class="full-width">
        <app-search-keyword-group
          [keywords]="keywords()"
          [formGroup]="formGroup()"
          [researchSource]="source()"
          [query]="formGroup().get('query')?.value"
        >
        </app-search-keyword-group>

        @if (loading) {
          <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
        }
        @if (!hasScopusAPIKey()) {
          <div class="test-query-wrapper">
            @if (testQueryCountResult) {
              <span>Estimated number of identified articles: {{ testQueryCountResult }}</span>
            } @else if (loading) {
              <span>Estimating... </span>
            } @else {
              <span class="spacer"></span>
            }
            <button mat-raised-button (click)="testCountQuery()">Estimate number of matches</button>
          </div>
        }
      </div>
      @if (showRegenerateButton) {
        <button mat-icon-button
          [matTooltip]="isGenerated() ? 'Regenerate query based on current keywords' : 'Regenerate query based on project settings'"
          (click)="regenerationQuery($event)">
          <mat-icon>restart_alt</mat-icon>
        </button>
      }
    </div>

  </div>
}
